import Api from '../utils/Api';
import Config from '../config/Config';

class PrexistenciaService {
  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntities([{ name: 'enfermedades' }]);
  }


  obtenerListaEnfermedadesPreExistente() {
    return this.api.endpoints.enfermedades
      .get()
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

}
export default new PrexistenciaService;
